"use client";
import { MEDIA_QUERIES as i } from "../tokens/media-queries/MediaQueries.js";
import { useState as a, useEffect as o } from "react";
const d = (s) => {
  const [e, n] = a(!1);
  return o(() => {
    const t = window.matchMedia(`(${i[s]})`);
    t.matches !== e && n(t.matches);
    const r = () => n(t.matches);
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [e, s]), e;
};
export {
  d as useMediaQuery
};
